import React from 'react';
import { Button, Input, Modal } from 'antd'

import requestAPI from 'helpers/requestAPI';
import { toastSuccess } from 'utils/toastr';

const Edit = ({ serverId }) => {
  
  const [ isModalVisible, setIsModalVisible ] = React.useState(false);
	const [ formState, setFormState ] = React.useState({
		name: '',
		server: '',
		port: '',
		username: '',
		password: ''
  });

  React.useEffect(() => {
		const params = {
			routeParams: {
        route: 'servers',
        serverId
			}
		};

		requestAPI(params)
    .then((response) => {
      const resp = response.data.data
      setFormState({
        ...formState,
        name: resp.name,
        server: resp.server,
        port: resp.port,
        username: resp.username,
        password: resp.password
      })
    })
    .catch((error) => {
      console.log(error);
    });
  // eslint-disable-next-line
  }, []);

  const toggleModalVisibility = React.useCallback(() => setIsModalVisible(isVisible => !isVisible), []);

  const handleFormDataChange = React.useCallback(event => {
    const { name, value } = event.target;
    setFormState(prevState => ({ ...prevState, [name]: value }))
  }, []);

  const sendData = React.useCallback(() => {
		const params = {
			routeParams: {
				route: 'servers',
				serverId
			},
			method: 'PUT',
			data: formState
		};

		requestAPI(params)
    .then(response => {
      toastSuccess(response.data.ms);
      toggleModalVisibility();
    })
    .catch(error => {
		  console.log(error);
    });
  }, [serverId, formState, toggleModalVisibility]);

	return (
		<div className="edit">
      <Button size={'small'} type="primary" onClick={toggleModalVisibility}>Edit</Button>
      <Modal
        title="Edit data server"
        visible={isModalVisible}
        onOk={sendData}
        onCancel={toggleModalVisibility}
      >
        <div className="add__items">
          <div className="add__items__item add__items__item--name">
            <div className="add__items__item__title">Name server:</div>
            <Input
            value={formState.name}
            onChange={handleFormDataChange}
            name="name"
            type="text"
            className="add__items__item__input"
          />
          </div>

          <div className="add__items__item add__items__item--ftp-server">
            <div className="add__items__item__title">FTP-address server:</div>
            <Input
              value={formState.server}
              onChange={handleFormDataChange}
              name="server"
              type="text"
              className="add__items__item__input"
            />
          </div>

          <div className="add__items__item add__items__item--port">
            <div className="add__items__item__title">Port server:</div>
            <Input
              value={formState.port}
              onChange={handleFormDataChange}
              name="port"
              type="text"
              className="add__items__item__input"
            />
          </div>

          <div className="add__items__item add__items__item--username">
            <div className="add__items__item__title">Username:</div>
            <Input
              value={formState.username}
              onChange={handleFormDataChange}
              name="username"
              type="text"
              className="add__items__item__input"
            />
          </div>

          <div className="add__items__item add__items__item--password">
            <div className="add__items__item__title">Password:</div>
            <Input
              value={formState.password}
              onChange={handleFormDataChange}
              name="password"
              type="text"
              className="add__items__item__input"
            />
          </div>
        </div>
      </Modal>
    </div>
	);
};

export default Edit;
